export default __webpack_public_path__ + "static/media/78d2e26b51b04099b574465cd673ad2f.267d26ae.png";